import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Stack from 'react-bootstrap/esm/Stack';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { states } from './QuoteEstimate/constants';
import { SocialIcon } from 'react-social-icons'
import axios from 'axios';
import { useState } from 'react';
import { Alert } from 'react-bootstrap';



export function ContactUs({ }) {

    const [validated, setValidated] = useState(false);
    const [form, setForm] = useState({})
    const [contacted, setContacted] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const handleSubmit = async (event) => {

        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        if (event.currentTarget.checkValidity()) {
            setContacted(true);
            await axios
                .post(`${process.env.REACT_APP_CORE_API}/contact`, { ...form, source: 'contact' })
                .catch(error => console.error('Contact submit failed:', error));
        }
    }

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    return (
        <Container style={{ paddingTop: '0', marginTop: '0' }}>
            <Row className="justify-content-md-center" style={{ marginTop: '0' }}>
                <div className="text-center" style={{ color: '#007EF2' }}>
                    <h2 className='racing-sans-one-regular' style={{ color: '#007EF2', marginTop: '0', paddingTop: '0' }}>
                        Questions? <span 
                            style={{ 
                                color: '#E00038', 
                                cursor: 'pointer', 
                                textDecoration: 'underline' 
                            }}
                            onClick={() => setShowModal(true)}
                        >
                            Contact us
                        </span>
                    </h2>
                </div>
            </Row>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className='racing-sans-one-regular' style={{ color: '#007EF2' }}>
                        Contact Us
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!contacted ?
                        <Form onChange={handleChange} noValidate validated={validated} onSubmit={handleSubmit} >
                            <Form.Group className="mb-3">
                                <Row>
                                    <Col>
                                        <Form.Control type="text" name="name" required placeholder="Enter First Name" />
                                    </Col>
                                </Row>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control name="email" type="email" required placeholder="Enter Email" />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control name="phone" type="tel" required minLength={10} maxLength={10} placeholder="Enter Phone" />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control as="textarea" name="message" required rows={3} placeholder='Enter message' />
                            </Form.Group>
                            <Button style={{ backgroundColor: "#E00038" }} type="submit">
                                <span className='racing-sans-one-regular' type="submit">Submit</span>
                            </Button>
                        </Form> :
                        <div>
                            <Alert key={"success"} variant={"success"}>
                                Thank you for contacting us! We will get back to you as soon as possible!
                            </Alert>
                        </div>
                    }
                </Modal.Body>
            </Modal>

            <Stack gap={1} className="justify-content-md-center text-center" style={{ marginTop: '1rem' }}>
                <Stack direction="horizontal" gap={2} style={{ justifyContent: "center" }}>
                    <SocialIcon url="https://www.instagram.com/quotemyinjury/" />
                </Stack>
            </Stack>
        </Container>
    );
}